// Templates default (fallback hardcoded) + utilities para renderizar
// e disparar mensagens de WhatsApp dinâmicas.

export const GATILHOS = [
  { id: "nova_promissoria",  label: "Nova Promissória",       padraoBotao: "Compartilhar WhatsApp" },
  { id: "lembrar_divida",    label: "Dívidas (Lembrar)",      padraoBotao: "Lembrar" },
  { id: "retorno_rota",      label: "Retorno de Rota",         padraoBotao: "WhatsApp" },
  { id: "recobranca",        label: "Recobrança",             padraoBotao: "WhatsApp" },
  { id: "pos_venda",         label: "Pós-Venda (Escritório)", padraoBotao: "Pós-Venda" },
];

export const VARIAVEIS_DISPONIVEIS = [
  { token: "{{nome_vendedor}}",      desc: "Nome do vendedor logado" },
  { token: "{{nome_loja}}",          desc: "Nome da loja/empresa" },
  { token: "{{nome_cliente}}",       desc: "Nome completo do cliente" },
  { token: "{{primeiro_nome}}",      desc: "Primeiro nome do cliente" },
  { token: "{{valor_total}}",        desc: "Valor total da nota (R$ x,xx)" },
  { token: "{{saldo_devedor}}",      desc: "Restante a pagar" },
  { token: "{{data_compra}}",        desc: "Data da compra (dd/mm/aaaa)" },
  { token: "{{data_vencimento}}",    desc: "Data de vencimento" },
  { token: "{{atraso_dias}}",        desc: "Dias de atraso (0 se ainda no prazo)" },
  { token: "{{link_pagamento}}",     desc: "Link da loja virtual (para pagar)" },
  { token: "{{link_segunda_via}}",   desc: "Link público da promissória PDF" },
  { token: "{{link_perfil_cliente}}",desc: "Link do perfil do cliente na loja" },
  { token: "{{link_loja}}",          desc: "Link da loja virtual" },
];

export const TEMPLATES_PADRAO = {
  nova_promissoria: `Olá {{nome_cliente}}! Parabéns pela sua compra!

📋 *Pedido:* {{numero_pedido}}
💰 *Valor Total:* {{valor_total}}
📅 *Vencimento:* {{data_vencimento}}

📎 *2ª via da Promissória*
LINK: {{link_segunda_via}}

🛍️ *Loja Virtual*
LINK: {{link_loja}}
Acompanhe seu prazo, adiantamento e vantagens pelo link.`,
  lembrar_divida: `Olá {{nome_cliente}}! Tudo bem?
Segue o lembrete da sua nota com vencimento em {{data_vencimento}}.

Valor total: {{valor_total}}
Restante: {{saldo_devedor}}

Ressaltando que o prazo final para pagamento é {{data_vencimento}}.
Pague online: {{link_pagamento}}

Obrigado!
*{{nome_loja}}*`,
  retorno_rota: `Olá {{primeiro_nome}}, tudo bem?
Aqui é da equipe {{nome_loja}} — passando para confirmar a próxima visita na sua rota.

Ref. pedido: {{valor_total}} | Vencimento {{data_vencimento}}

Qualquer dúvida, estou à disposição por aqui!`,
  recobranca: `Olá {{primeiro_nome}}, tudo bem?

Identificamos que sua nota está com *{{atraso_dias}} dia(s) de atraso*.

Valor total: {{valor_total}}
Saldo devedor: *{{saldo_devedor}}*
Vencimento original: {{data_vencimento}}

Pedimos que entre em contato o quanto antes para regularização.
Pague online: {{link_pagamento}}

Caso o pagamento já tenha sido efetuado, desconsidere esta mensagem e nos envie o comprovante.

*{{nome_loja}}*`,
  pos_venda: `Olá {{primeiro_nome}}, tudo bem?
Aqui é a {{nome_vendedor}}, do pós-venda da {{nome_loja}}.

*Estou passando para saber como está sendo sua experiência com os itens que você adquiriu na semana passada! Esperamos que eles estejam superando suas expectativas.*

*Sua opinião é muito importante para nós, pois queremos garantir que você tenha sempre o melhor resultado com nossos produtos.*

Qualquer dúvida ou suporte que precisar, estou à disposição por aqui!

_Apenas para conferência de sistema:_
Ref. pedido de {{valor_total}} (Vencimento {{data_vencimento}})`,
};

export const BOTOES_PADRAO = {
  nova_promissoria: "Compartilhar WhatsApp",
  lembrar_divida:   "Lembrar",
  retorno_rota:     "WhatsApp",
  recobranca:       "Recobrança",
  pos_venda:        "Pós-Venda",
};

// ============== render ==============

export const renderTemplate = (template, vars) => {
  if (!template) return "";
  return template.replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (_, key) => {
    const v = vars[key];
    return (v === undefined || v === null) ? "" : String(v);
  });
};

// Lê mensagens_whatsapp da loja_config (cached em localStorage por 60s).
let _mensagensCache = null;
let _mensagensTs = 0;

export const limparCacheMensagens = () => {
  _mensagensCache = null; _mensagensTs = 0;
};

export const getMensagensConfig = async () => {
  const agora = Date.now();
  if (_mensagensCache && (agora - _mensagensTs) < 60_000) return _mensagensCache;
  try {
    const axios = (await import("axios")).default;
    const API = `${window.location.origin}/api`;
    const { data } = await axios.get(`${API}/loja/config`);
    _mensagensCache = data?.mensagens_whatsapp || {};
    _mensagensTs = agora;
    return _mensagensCache;
  } catch (_) {
    return {};
  }
};

// Retorna { botao, template } final (custom OU padrão se vazio).
export const resolverMensagem = async (gatilho) => {
  const cfg = await getMensagensConfig();
  const m = cfg[gatilho] || {};
  return {
    botao:    (m.botao    || "").trim() || BOTOES_PADRAO[gatilho]    || "WhatsApp",
    template: (m.template || "").trim() || TEMPLATES_PADRAO[gatilho] || "",
  };
};

// ============== build vars + dispatch ==============

const fmtMoeda = (v) => `R$ ${(Number(v) || 0).toFixed(2).replace(".", ",")}`;
const fmtDateBR = (iso) => {
  if (!iso) return "";
  const s = String(iso).split("T")[0];
  const [y, m, d] = s.split("-");
  return (y && m && d) ? `${d}/${m}/${y}` : s;
};
const diasAtraso = (vencIso) => {
  if (!vencIso) return 0;
  const s = String(vencIso).split("T")[0];
  const [y, m, d] = s.split("-").map(Number);
  if (!y || !m || !d) return 0;
  const venc = new Date(y, m - 1, d).getTime();
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
  const diff = Math.floor((hoje.getTime() - venc) / 86_400_000);
  return diff > 0 ? diff : 0;
};

// Constrói as variáveis a partir de promissoria + cliente + usuário logado.
export const buildVarsFromPromissoria = ({ promissoria = {}, cliente = {}, user = null }) => {
  const u = user || JSON.parse(localStorage.getItem("user") || "{}");
  const origin = window.location.origin;
  const nomeCliente = promissoria.cliente_nome || cliente.nome_completo || cliente.nome || "";
  const primeiroNome = nomeCliente.split(" ")[0] || nomeCliente;
  const valorTotal = Number(promissoria.valor_total || 0);
  const valorPago = Number(promissoria.valor_pago || 0);
  const saldo = Math.max(0, valorTotal - valorPago);
  const tokenPub = promissoria.token_publico || promissoria.token || "";
  const linkSegundaVia = (promissoria.id && tokenPub)
    ? `${origin}/api/promissorias/${promissoria.id}/pdf-publico?token=${tokenPub}`
    : "";
  // Link share por tenant — abre a loja do dono da promissória, não do super admin.
  // Usa o endpoint /api/loja/share/{uid} para que o WhatsApp já mostre nome + logo da loja certa.
  const ownerId = promissoria.user_id || u?.id || "";
  const linkLoja = ownerId ? `${origin}/api/loja/share/${ownerId}` : `${origin}/loja`;
  return {
    nome_vendedor:       u.nome || "",
    nome_loja:           u.nome_loja || "",
    nome_cliente:        nomeCliente,
    primeiro_nome:       primeiroNome,
    numero_pedido:       promissoria.numero_pedido || "",
    valor_total:         fmtMoeda(valorTotal),
    saldo_devedor:       fmtMoeda(saldo),
    data_compra:         fmtDateBR(promissoria.data_compra),
    data_vencimento:     fmtDateBR(promissoria.data_vencimento),
    atraso_dias:         String(diasAtraso(promissoria.data_vencimento)),
    link_pagamento:      linkLoja,
    link_segunda_via:    linkSegundaVia,
    link_perfil_cliente: linkLoja,
    link_loja:           linkLoja,
  };
};

// Constrói número WhatsApp E.164 (DDI + número, só dígitos).
export const buildNumeroWhatsApp = (telefone) => {
  const limpo = String(telefone || "").replace(/\D/g, "");
  if (!limpo) return "";
  if (limpo.startsWith("595")) return limpo;          // Paraguai
  if (limpo.startsWith("55"))  return limpo;          // já com DDI BR
  return `55${limpo}`;
};

// Disparo final: monta texto + abre wa.me.
export const enviarWhatsApp = async ({ gatilho, telefone, vars = {}, extras = {} }) => {
  const { template } = await resolverMensagem(gatilho);
  const texto = renderTemplate(template, { ...vars, ...extras });
  const num = buildNumeroWhatsApp(telefone);
  const url = num
    ? `https://wa.me/${num}?text=${encodeURIComponent(texto)}`
    : `https://wa.me/?text=${encodeURIComponent(texto)}`;
  window.open(url, "_blank");
  return { url, texto };
};
